export default __webpack_public_path__ + "static/remove-branding-604fbdc8af4c6ce0ec8579adfae1d427.png";